import React, { FC } from 'react';

import { EvTitle } from '@evinced-private/ui-common';

import { ScoreData } from '../../services/queries/score/helpers/transformResults';
import { AccessibilityCriticalIssuesStackedChartContainer } from '../accessibility-critical-issues-stacked-chart';
import { ChartIssuesInput } from '../accessibility-critical-issues-stacked-chart/types';
import { AccessibilityTrendsChartContainer } from '../accessibility-trends-chart/AccessibilityTrendsChartContainer';

interface BusinessUnitChartsSectionProps {
	uniqueIssuesData?: ChartIssuesInput;
	isDashboardDataLoading: boolean;
	dashboardDataError: unknown;
	scoreData?: ScoreData[];
	isScoreDataLoading?: boolean;
	scoreDataError?: unknown;
	dashboardData?: ChartIssuesInput;
}

export const BusinessUnitChartsSection: FC<BusinessUnitChartsSectionProps> = ({
	uniqueIssuesData,
	isDashboardDataLoading,
	dashboardDataError,
	scoreData,
	isScoreDataLoading,
	scoreDataError,
	dashboardData
}) => {
	return (
		<section className="trends-charts-section" role="group" aria-labelledby="trends-heading">
			<EvTitle id="trends-heading" titleText="Accessibility performance trends" />
			<div className="business-units-charts">
				<AccessibilityTrendsChartContainer
					scoreData={scoreData}
					isLoading={isScoreDataLoading}
					error={scoreDataError}
				/>
				<AccessibilityCriticalIssuesStackedChartContainer
					data={dashboardData}
					uniqueIssuesData={uniqueIssuesData}
					isLoading={isDashboardDataLoading}
					error={dashboardDataError}
				/>
			</div>
		</section>
	);
};
